import type { Dayjs } from 'dayjs';
import { DatePicker } from 'antd';
import { cn } from 'cn';
import { DATE_TIME_FORMAT } from '@/std/const/date';
import { isTouchDevice } from '@/std/platform';
import { getValue, type PickProps } from './util';

export function PickDateTime({
    className,
    disabled,
    format = DATE_TIME_FORMAT,
    placeholder = 'Selecionar data e hora',
    value,
    onChange,
}: PickProps) {
    const handleChange = (date: Dayjs | null, dateString: string | string[] | null): void => {
        const str = Array.isArray(dateString) ? dateString.join() : dateString;
        onChange?.(str, date);
    };

    return (
        <DatePicker
            allowClear={true}
            className={cn('w-full', className)}
            disabled={disabled}
            format={format}
            inputReadOnly={isTouchDevice()}
            onChange={handleChange}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }}
            placeholder={placeholder}
            showTime={true}
            value={getValue(value, format)}
        />
    );
}
